// eslint-disable-next-line boundaries/no-unknown-files
import { createApi } from '@reduxjs/toolkit/query/react';
import reducerPath from "../../../../app/reducerPath";
// eslint-disable-next-line boundaries/element-types
import createHeadRequest from "../../../../shared/http/createHeadRequest";
// eslint-disable-next-line boundaries/element-types
import checkStatus from "../../../../shared/http/checkStatus";
// eslint-disable-next-line boundaries/element-types
import HttpMethods from "../../../../shared/api/HttpMethods";
// eslint-disable-next-line import/no-named-as-default
import sensorResourceTypeFromDtoService from "../services/data/sensorResourceType-from-dto.service";
// eslint-disable-next-line boundaries/element-types
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from "../../../baseQueryWithReAuth/baseQueryWithReAuth";
import config from '../../../../shared/api/config';

// Описываем методы обращения к беку
export const sensorResourceTypeApi = createApi({
  reducerPath: `${reducerPath.sensorResourceType}/api`,
  tagTypes: ['TAG'],
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.baseUrl}/sensor-types`),
  endpoints: (builder) => ({
    getSensorTypes: builder.query({
      query: () => ({
        ...createHeadRequest({
          url: ``, method: HttpMethods.GET
        }),
        validateStatus: checkStatus,
      }),
      transformResponse: sensorResourceTypeFromDtoService
    }), // +
  }),
});

export const { useGetSensorTypesQuery } = sensorResourceTypeApi;
